"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var logo_no_icon_svg_1 = __importDefault(require("../../assets/images/logo-no-icon.svg"));
var Policies_1 = require("../classes/Policies");
var School_1 = require("../classes/School");
var Order_1 = require("../classes/Order");
var Cashier_1 = require("../classes/Cashier");
var changelogUnread_1 = require("../common/helpers/changelogUnread");
var ThirdPartyLibraries_1 = require("../../DriveScout/Billing/ThirdPartyLibraries");
var AdminController = /** @class */ (function () {
    function AdminController($q, $rootScope, $state, AUTH_EVENTS, UserService, ToasterService, CreateOrderService, PoliciesModel, ENV, currentUser, VueStoreFactory, PolicyService, SchoolsModel, ChangelogModel) {
        var _this = this;
        this.$q = $q;
        this.ENV = ENV;
        this.loading = true;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.AUTH_EVENTS = AUTH_EVENTS;
        this.UserService = UserService;
        this.VueStoreFactory = VueStoreFactory;
        this.PolicyService = PolicyService;
        this.SchoolsModel = SchoolsModel;
        this.ChangelogModel = ChangelogModel;
        // this.PusherService = PusherService;
        this.currentUser = UserService.getCurrentUser();
        this.ToasterService = ToasterService;
        this.CreateOrderService = CreateOrderService;
        this.PoliciesModel = PoliciesModel;
        // PusherService.subscribe();
        this.adminHeaderImage = logo_no_icon_svg_1.default;
        this.setSchoolName();
        this.setSchoolMode();
        this.setUserName();
        this.configureCashier();
        this.setSchoolName = this.setSchoolName.bind(this);
        this.setSchoolMode = this.setSchoolMode.bind(this);
        this.getAdminPadding = this.getAdminPadding.bind(this);
        this.$rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
            _this.setSchoolName();
        });
        this.plan = {
            name: "",
            description: "",
            past_due: false,
            delinquent: false,
        };
        this.invoices = [];
        this.getPlan();
        this.changelog = {
            visible: ["admin", "owner", "administrator", "staff"].includes(this.currentUser.role.type),
            unread: false,
        };
        this.checkChangelog();
        this.goToChangelog = this.goToChangelog.bind(this);
        this.state = {
            search: {
                selectedUser: null,
                studentSchoolOverride: false,
                roles: ["student", "instructor"],
                handleSelectUser: function (user) {
                    if (user === null) {
                        return;
                    }
                    if (user.type === "student") {
                        // go to student
                        _this.$state.go("drivecoach.admin.students.view", {
                            userId: user.id,
                        }, { reload: true });
                    }
                    if (user.type === "instructor") {
                        // go to instructor
                        _this.$state.go("drivecoach.admin.instructors.view", {
                            instructorId: user.id,
                        });
                    }
                },
            },
        };
    }
    AdminController.prototype.checkChangelog = function () {
        var _this = this;
        if (!this.changelog.visible) {
            return;
        }
        this.ChangelogModel.getLatest()
            .then(function (response) {
            _this.changelog.unread = (0, changelogUnread_1.changelogIsUnread)(response.published_at, localStorage.getItem(changelogUnread_1.CHANGELOG_READ_AT_KEY), new Date());
        })
            .catch(function () {
            // No badge on failure -- the icon still links to the changelog page.
            _this.changelog.unread = false;
        });
    };
    AdminController.prototype.goToChangelog = function () {
        localStorage.setItem(changelogUnread_1.CHANGELOG_READ_AT_KEY, new Date().toISOString());
        this.changelog.unread = false;
        this.$state.go("drivecoach.admin.changelog");
    };
    AdminController.prototype.getAdminPadding = function () {
        if (this.plan.past_due === true) {
            return { "padding-top": "0px" };
        }
        return { "padding-top": "45px" };
    };
    AdminController.prototype.getPlan = function () {
        var _this = this;
        this.SchoolsModel.getSchoolPlan(this.currentUser.school_id).then(function (response) {
            _this.plan = __assign(__assign({}, response.drivescout.plan), { past_due: response.drivescout.past_due, delinquent: response.drivescout.delinquent || false });
            if (_this.plan.delinquent) {
                _this.SchoolsModel.getSchoolInvoices(_this.currentUser.school_id).then(function (invoices) {
                    _this.invoices = invoices.invoices;
                });
            }
        });
    };
    AdminController.prototype.configureCashier = function () {
        var _this = this;
        this.$q
            .all([
            this.PoliciesModel.getAll(),
            this.SchoolsModel.getSchoolByID(this.currentUser.school_id),
        ])
            .then(function (responses) {
            var response = responses[0];
            var schoolResponse = responses[1];
            _this.VueStoreFactory.dispatch("SET_POLICIES", response);
            var policies = (0, Policies_1.createFromPolicyAPIResponse)(response);
            var school = new School_1.School(__assign(__assign({}, response.school), { policies: policies.toArray() }));
            policies.setSchool(school);
            school.setPolicies(policies);
            var cashier = new Cashier_1.Cashier(school, new Order_1.Order());
            _this.CreateOrderService.cashier(cashier);
            _this.PolicyService.setPolicies(policies);
            if (cashier.school().billingGatway().name().toLowerCase() === "authorize") {
                (0, ThirdPartyLibraries_1.initAcceptJS)(_this.ENV);
            }
            if (cashier.school().billingGatway().name().toLowerCase() === "stripe") {
                (0, ThirdPartyLibraries_1.initStripe)(_this.ENV);
            }
            _this.VueStoreFactory.dispatch("SET_SCHOOL", __assign(__assign({}, schoolResponse), { policies: policies.toArray() }));
            _this.loading = false;
        });
    };
    AdminController.prototype.setSchoolName = function () {
        this.schoolName = this.currentUser.school.name;
    };
    AdminController.prototype.setSchoolMode = function () {
        this.schoolMode = this.currentUser.school.status;
    };
    AdminController.prototype.setUserName = function () {
        this.user = this.currentUser;
    };
    return AdminController;
}());
AdminController.$inject = [
    "$q",
    "$rootScope",
    "$state",
    "AUTH_EVENTS",
    "UserService",
    "ToasterService",
    "CreateOrderService",
    "PoliciesModel",
    "ENV",
    "currentUser",
    "VueStoreFactory",
    "PolicyService",
    "SchoolsModel",
    "ChangelogModel",
];
exports.default = AdminController;
